export enum TaskType {
    Pending,
    ASAP,
    Scheduled,
    Permanent
}
